import jwtAxios from "@/util/jwtAxios.js";

const API_URL = import.meta.env.VITE_API_URL;

export const createFaq = async ({title,des})=>{
    try {
        return await jwtAxios.post(`${API_URL}faq`,{title:title,des:des});
    } catch (e) {
        return e;
    }
}

export const updateFaq = async ({title,des, id})=>{
    try {
        return await jwtAxios.put(`${API_URL}faq/${id}`,{title:title, des:des,id:id});
    } catch (e) {
        return e;
    }
}

export const deleteFaq = async (id) =>{
    try {
        return await jwtAxios.delete(`${API_URL}faq/${id}`,{})
    } catch (e) {
        return e;
    }
}

export const getFaq = async (id) =>{
    try {
        return await jwtAxios.get(`${API_URL}faqs/${id}`);
    } catch (error) {
        return error;
    }
}

export const getFaqs = async () =>{
    try {
        return await jwtAxios.get(`${API_URL}faq/`);
    } catch (error) {
        return error;
    }
}